import {VimeoBackground} from "@/components/Video/VimeoBackground";
import * as C from "@/components";
import React from "react";
import css from "./snaptix-aroma-discreet.module.scss";

interface SnaptixAromaDiscreetProps {
    pageContent: Record<string, any>;
    videoId: number;
}

export const SnaptixAromaDiscreet = ({ pageContent, videoId }: SnaptixAromaDiscreetProps ) => (
    <C.Card className='mx-3 my-3 w-full md:w-[56.7%] max-sm:min-h-[440px] max-md:min-h-[750px]' style={{ padding: 0 }}>
        <div className="absolute w-full z-[21]">
            <div className='text-center space-y-3 pt-10 md:pt-20'>
                <h3 className='text-3xl md:text-4xl'>
                    {pageContent["aroma-discreet.headline"]?.data ?? ""}</h3>
                <p className='px-4'>
                    {pageContent["aroma-discreet.body"]?.data ?? ""}</p>
            </div>
        </div>
        <div className={`relative w-full h-full ${css['video-space']}`}>
            <div className='absolute bottom-0 w-full'>
                <VimeoBackground videoId={videoId} className='-translate-y-1/2' unlistedPrivacyHash={'958dfcd0eb'} isVideoUnlisted />
            </div>
        </div>
    </C.Card>
);
